import { Helmet } from 'react-helmet-async'

import {
  Box, Button, Columns, PageHeader,
} from '@domain-group/suit-theme'

import useTaskList from '@hooks/useTaskList'

import EntityActivity from '@components/EntityActivity'

import { generateTabBarItems } from '@sections/Admin/packs/Projects/screens/Detail/functions/generateTabBarItems'

import Assets from '../Assets'
import Contacts from '../Contacts'
import Details from '../Details'
import Links from '../Links'
import TaskListSections from '../TaskListSections'

interface PageContentProps {
  taskListId: number,
}

const PageContent = (props: PageContentProps) => {
  const { taskListId } = props

  const taskListPayload = useTaskList({ id: taskListId })
  const {
    taskList,
    taskList: {
      id,
      title,
    },
    urls: { taskListsIndexUrl },
  } = taskListPayload

  return (
    <>
      <Helmet>
        <title>Project | Template Manager</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <Button
            as="a"
            buttonStyle="secondaryUtility"
            href={taskListsIndexUrl}
            size="medium"
            width="auto"
          >
            Back
          </Button>
        )}
        activeTabBarItemKey="overview"
        boxProps={{ height: [112, 105], justifyContent: 'flex-start' }}
        nestedNavigation
        tabBarItems={generateTabBarItems(taskList)}
        title="Overview"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <Details taskListPayload={taskListPayload} />
            <TaskListSections taskList={taskList} />
            <EntityActivity
              componentSettings={{
                conversation: {
                  title: `Project for ${title}`,
                },
              }}
              subjectType="TaskList"
              subjectId={id}
            />
          </Columns.Main>

          <Columns.Sidebar>
            <Contacts taskList={taskList} />
            <Assets taskList={taskList} />
            <Links taskList={taskList} />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
